import React from 'react';
import SingleColumnTemplate from '../../../../ui/layouts/SingleColumnTemplate.jsx';
import Button from '../../../../ui/canon/Button.jsx';
import AssistantModalV2 from '../../assistant/components/AssistantModalV2.jsx';
import { suggestedTopics as topics, quickPrompts } from '../../assistant/data/assistantData';

class AssistantModalTest extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false, mode: 'empty', initialMessage: '' };
  }

  openEmpty = () => { this.setState({ mode: 'empty', initialMessage: '', open: true }); };
  openTopics = () => { this.setState({ mode: 'topics', initialMessage: '', open: true }); };
  openPrompts = () => { this.setState({ mode: 'prompts', initialMessage: '', open: true }); };
  openContext = () => { this.setState({ mode: 'context', initialMessage: 'Explain my $1.02M valuation breakdown', open: true }); };

  propsForModal() {
    const { mode } = this.state;
    if (mode === 'topics') return { suggestedTopics: topics.slice(0, 6) };
    if (mode === 'prompts') return { contextualPrompts: quickPrompts.slice(0, 6) };
    return {};
  }

  render() {
    const companyName = (this.props && (this.props.company?.branded_name || this.props.company?.name)) || 'FindBob';
    const { open, initialMessage } = this.state;
    return (
      <SingleColumnTemplate title="Assistant Modal – Test Harness" columnClassName="max-w-3xl">
        <h3 className="m-0 p-0 mb-2">Modal Tests</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <Button variant="outline" onClick={this.openEmpty}>Open Empty</Button>
          <Button variant="outline" onClick={this.openTopics}>Open with Topics</Button>
          <Button variant="outline" onClick={this.openPrompts}>Open with Prompts</Button>
          <Button variant="outline" onClick={this.openContext}>Open with Context</Button>
        </div>

        <AssistantModalV2
          open={open}
          onOpenChange={(o) => this.setState({ open: o })}
          companyBrandedName={companyName}
          initialMessage={initialMessage}
          {...this.propsForModal()}
        />
      </SingleColumnTemplate>
    );
  }
}

export default AssistantModalTest;


